import React from "react";
import { FaSearch } from "react-icons/fa";
import { Card, Title } from "../components/AllExportedComponent";

function Projects() {
    const [query, setQuery] = React.useState('');
    return <>
        <div className="w-full">
            <div className="w-full flex flex-col mt-12 mb-10">
                <Title title="Proyek" subtitle="Saya" />
                <div className="relative flex justify-center w-full flex-wrap mt-8">
                    <div className="flex">
                        <span className="z-10 h-full font-normal absolute text-center bg-transparent rounded text-gray-600 items-center justify-center w-8 pl-3 py-3">
                            <FaSearch />
                        </span>
                        <input type="text" value={query} onChange={e => setQuery(e.target.value)} placeholder="cari apa?" name="search" id="search" className="px-3 py-3 relative bg-white rounded-full text-gray-600 text-sm shadow focus:outline-none focus:ring w-80 sm:w-96 md:w-[28rem] lg:w-[32rem] xl:w-[36rem] 2xl:w-[40rem] pl-10"/>
                    </div>
                </div>
            </div>
            <div className="w-100 flex justify-center items-center">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 3xl:grid-cols-4">
                    <Card query={query} />
                </div>
            </div>
        </div>
    </>
}

export default Projects;